import { render, staticRenderFns } from "./OfertaSingle.vue?vue&type=template&id=81d53972&scoped=true&lang=pug"
import script from "./OfertaSingle.vue?vue&type=script&lang=js"
export * from "./OfertaSingle.vue?vue&type=script&lang=js"
import style0 from "./OfertaSingle.vue?vue&type=style&index=0&id=81d53972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d53972",
  null
  
)

export default component.exports